import React, { useState, useContext, useRef } from "react";
import styled from "styled-components";
import { OverlayPanel } from "primereact/overlaypanel";
import { Loader } from "@vds/loaders";
import moreIcon from "../../assets/icons/more.png";
import { switchTab } from "./utils";
import moment from "moment";
import { C4SContext } from "../../context/c4sContext";
import Icon from "@vds/icons";
import { Title } from "@vds/typography";
import { Modal, ModalBody, ModalFooter } from "@vds/modals";
import { cancelWorkticket } from "../../services/C4S Decommission - Replacement/cancelWorkticket";
import { buildReturnReshipPayload, returnReship } from "../../services/C4S Decommission - Replacement/returnsHelper";
import { CustomSLButton, FlexRow, Spacer } from "../../components/core/utility";
import WTCommonModal from "./WTCommonModal";
import UpdateAddressContactModal from "./UpdateAddressContactModal";
import { getOpenJobsTabIndexFromSession } from "./navigation/tabHelpers";

const Options = styled.div`
  font-family: Verizon-NHG-eTX, Helvetica, Ariel, sans-serif;
  font-size: 12px;
  color: #000;
  margin-top: ${(props) => (props.marginTop ? props.marginTop : "0.4rem")};
  cursor: pointer;
`;

const ThreeDotsTemplateWTA = React.memo(function ThreeDotsTemplateWTA({
  ticketDetails,
  notify,
  getWorkTicketList,
  id,
  userId,
  renderSplitByMaterial,
}) {
  const { source, notification } = useContext(C4SContext);
  const cspDetails = JSON.parse(sessionStorage.getItem("CSPDetails"));
  const [component, setComponent] = useState(null);
  const [isLoading, setLoader] = useState(false);
  let moreOperations = useRef(null);

  const buttonRef = useRef(null);
  const [isCancelOptionModal, setIsCancelOptionModal] = useState(false);
  const [commonModalStatus, setCommonModalStatus] = useState(false);
  const [modal, setModal] = useState("");
  const [return_ReshipModalStatus, setReturn_ReshipModalStatus] = useState(false);
  const [title, setTitle] = useState("");
  const [subTitle, setSubTitle] = useState("");
  const [actionItem, setActionItem] = useState("");
  const [isAddressUpdateModal, setIsAddressUpdateModal] = useState(false);
  const [splitByMaterialModal, setSplitByMaterialModal] = useState(false);
  const [splitByAckSelected, setSplitByAckSelected] = useState(false);

  const handleHamburgerActions = (action) => {
    moreOperations.current.hide();
    switch (action) {
      case "Update":
        setIsAddressUpdateModal(true);
        break;
      case "Split":
        setSplitByMaterialModal(true);
        break;
      case "Schedule":
        if (
          ticketDetails.installType === "VMI" &&
          ticketDetails?.hasEsnToBeReturned !== "true" &&
          (ticketDetails?.status?.toLowerCase() === "released" ||
            ticketDetails?.status?.toLowerCase() === "shipped" ||
            ticketDetails?.status?.toLowerCase() === "backordered" ||
            ticketDetails?.status?.toLowerCase() === "created" ||
            ticketDetails?.status?.toLowerCase() === "submitted" ||
            ticketDetails?.status?.toLowerCase() === "packaging" ||
            ticketDetails?.status?.toLowerCase() === "delivered")
        ) {
          redirectToAddJobPage();
        }
        break;
      case "Cancel":
        setIsCancelOptionModal(true);
        break;
      case "CancelShipment":
        setCommonModalStatus(true);
        setTitle("Cancel Work Ticket");
        setSubTitle("Select Reason");
        setActionItem("CancelShipment");
        break;
      case "Return_Reship":
        setCommonModalStatus(true);
        setTitle("Return/Reship Reason");
        setModal("Return/Reship");
        setSubTitle("Select Reason");
        if (ticketDetails?.status?.toLowerCase() === "shipped") {
          setActionItem("ReturnReshipShipped");
        } else if (ticketDetails?.status?.toLowerCase() === "delivered") {
          setActionItem("ReturnReshipDelivered");
        }
        break;
      case "ReshipOnly":
        setCommonModalStatus(true);
        setTitle("Reship Reason");
        setModal("Reship");
        setSubTitle("Select Reason");
        if (ticketDetails?.status?.toLowerCase() === "shipped") {
          setActionItem("ReshipOnlyShipped");
        } else if (ticketDetails?.status?.toLowerCase() === "delivered") {
          setActionItem("ReshipOnlyDelivered");
        }
        break;
      case "ReturnOnly":
        handleReturnOnlyDirect();
        break;
    }
  };

  const handleReturnOnlyDirect = async () => {
    setLoader(true);
    const payload = buildReturnReshipPayload({
      ticketDetails,
      cspDetails,
      action: "Return",
      returnReason: "",
      returnSubReason: "",
    });

    const response = await returnReship(payload);
    if (response?.status === 200 && response?.data) {
      notify("Return processed successfully", "success");
      getWorkTicketList();
    } else {
      notify("Unable to process return due to an unexpected error", "error");
    }
    setLoader(false);
  };

  const handleCancelWorkTicket = async () => {
    let cspAccDetails = cspDetails?.CSP?.filter((cspDetail) => cspDetail.DefaultCSP === "1")[0] || "";
    let salesOrgNumber = ticketDetails?.salesOrg.split(" ")[0];
    let payload = {
      cspId: cspAccDetails?.CSPID || "",
      workticketId: ticketDetails.ticketId ?? "",
      salesOrg: salesOrgNumber ?? "",
      erpTicketType: source.source === "CSP" ? "ZINS" : "ZSRQ",
      modifiedBy: `${cspDetails?.firstName} ${cspDetails?.lastName}`,
      modifiedByEmail: cspDetails?.email || "",
      modifiedByEid: cspDetails?.Employee_ID || "",
      assignedTo:
        cspDetails?.source === "CSP"
          ? cspDetails?.CSP.length
            ? cspDetails?.CSP.filter((csp) => csp?.DefaultCSP === "1")[0].CSPOwner
            : null
          : cspDetails?.CASEDetails.length
          ? cspDetails?.CASEDetails.filter((cases) => cases.DefaultCase === "1")[0].CaseOwner
          : null,
      assignedToEmail:
        cspDetails?.source === "CSP"
          ? cspDetails?.CSP.length
            ? cspDetails?.CSP.filter((csp) => csp?.DefaultCSP === "1")[0].CSPOwnerEmail
            : null
          : cspDetails?.CASEDetails.length
          ? cspDetails?.CASEDetails.filter((cases) => cases.DefaultCase === "1")[0].CaseOwnerEmail
          : null,
      assignedToEid:
        cspDetails?.source === "CSP"
          ? cspDetails?.CSP.length
            ? cspDetails?.CSP.filter((csp) => csp?.DefaultCSP === "1")[0].CSPOwnerEId
            : null
          : cspDetails?.CASEDetails.length
          ? cspDetails?.CASEDetails.filter((cases) => cases.DefaultCase === "1")[0].CaseOwnerEId
          : null,
    };
    let missingFieldsArray = [];
    for (const key of Object.keys(payload)) {
      if (key === "workticketId" || key === "salesOrg") {
        if (payload[key] === "" || payload[key] === undefined || payload[key] === null) {
          missingFieldsArray.push(key);
        }
      }
    }
    if (missingFieldsArray.length > 0) {
      setIsCancelOptionModal(false);
      return setTimeout(() => {
        notify(
          "Unable to cancel work ticket due to missing information. Kindly contact IT team for support. Missing information: " +
            missingFieldsArray.toString() +
            ".",
          "error",
          false
        );
      }, 10);
    }
    setLoader(true);
    let response = await cancelWorkticket(payload);

    if (response.status === 200 && response?.data?.statusCode === "200") {
      notify("Ticket has been canceled successfully!", "success");
      getWorkTicketList();
      setIsCancelOptionModal(false);
      setTimeout(() => {
        notification.setNotification(null);
      }, 3000);
    } else {
      notify("We are currently experiencing issues, please try again", "error");
      setIsCancelOptionModal(false);
    }
    setLoader(false);
  };

  const handleCancelShipment = async (desc, subCode) => {
    let cspAccDetails = cspDetails?.CSP?.filter((cspDetail) => cspDetail.DefaultCSP === "1")[0] || "";
    let salesOrgNumber = ticketDetails?.salesOrg.split(" ")[0];
    let payload = {
      cspId: cspAccDetails?.CSPID || "",
      workticketId: ticketDetails.ticketId ?? "",
      cancellationReason: desc,
      cancellationReasonCode: subCode,
      salesOrg: salesOrgNumber ?? "",
      erpTicketType: source.source === "CSP" ? "ZINS" : "ZSRQ",
      modifiedBy: `${cspDetails?.firstName} ${cspDetails?.lastName}`,
      modifiedByEmail: cspDetails?.email || "",
      modifiedByEid: cspDetails?.Employee_ID || "",
      assignedTo:
        cspDetails?.source === "CSP"
          ? cspDetails?.CSP.length
            ? cspDetails?.CSP.filter((csp) => csp?.DefaultCSP === "1")[0].CSPOwner
            : null
          : cspDetails?.CASEDetails.length
          ? cspDetails?.CASEDetails.filter((cases) => cases.DefaultCase === "1")[0].CaseOwner
          : null,
      assignedToEmail:
        cspDetails?.source === "CSP"
          ? cspDetails?.CSP.length
            ? cspDetails?.CSP.filter((csp) => csp?.DefaultCSP === "1")[0].CSPOwnerEmail
            : null
          : cspDetails?.CASEDetails.length
          ? cspDetails?.CASEDetails.filter((cases) => cases.DefaultCase === "1")[0].CaseOwnerEmail
          : null,
      assignedToEid:
        cspDetails?.source === "CSP"
          ? cspDetails?.CSP.length
            ? cspDetails?.CSP.filter((csp) => csp?.DefaultCSP === "1")[0].CSPOwnerEId
            : null
          : cspDetails?.CASEDetails.length
          ? cspDetails?.CASEDetails.filter((cases) => cases.DefaultCase === "1")[0].CaseOwnerEId
          : null,
    };
    let missingFieldsArray = [];
    for (const key of Object.keys(payload)) {
      if (key === "workticketId" || key === "salesOrg") {
        if (payload[key] === "" || payload[key] === undefined || payload[key] === null) {
          missingFieldsArray.push(key);
        }
      }
    }
    if (missingFieldsArray.length > 0) {
      setCommonModalStatus(false);
      return setTimeout(() => {
        notify(
          "Unable to cancel work ticket due to missing information. Kindly contact IT team for support. Missing information: " +
            missingFieldsArray.toString() +
            ".",
          "error",
          false
        );
      }, 10);
    }
    setLoader(true);
    let response = await cancelWorkticket(payload);

    if (response.status === 200 && response?.data?.statusCode === "200") {
      if (response?.data?.message === "Success") {
        if (response?.data?.data?.code === "200") {
          notify(response?.data?.data?.messageDescription, "success");
          getWorkTicketList();
        } else {
          notify(response?.data?.data?.messageDescription, "error");
        }
      } else {
        notify(response?.data?.data?.messageDescription, "error");
      }
      setCommonModalStatus(false);
      setTimeout(() => {
        notification.setNotification(null);
      }, 5000);
    } else {
      notify("We are currently experiencing issues, please try again", "error");
      setCommonModalStatus(false);
      setTimeout(() => {
        notification.setNotification(null);
      }, 5000);
    }
    setLoader(false);
  };

  const handleShipmentDamagedModal = () => {
    // Logic for handling shipment damaged modal
    setTitle("Who Damaged the Package?");
    setSubTitle("Select Who Damaged the Package");
    setActionItem("DamagedPackage");
    setCommonModalStatus(true);
  };

  const handleLostShipmentModal = () => {
    // Logic for handling lost shipment modal
    setTitle("Who Lost the Package?");
    setSubTitle("Select Who Lost the Package");
    setActionItem("LostPackage");
    setCommonModalStatus(true);
  };

  const hasOptions = (() => {
    const status = ticketDetails?.status?.toLowerCase();
    const hasEsnToBeReturned = ticketDetails?.hasEsnToBeReturned === "true";
    const isVMISchedulable =
      ticketDetails?.installType === "VMI" &&
      !hasEsnToBeReturned &&
      (status === "released" ||
        status === "shipped" ||
        status === "backordered" ||
        status === "created" ||
        status === "submitted" ||
        status === "packaging" ||
        status === "delivered");
    return (
      isVMISchedulable ||
      status === "error" ||
      ((status === "released" || status === "backordered" || status === "submitted" || status === "created") && ticketDetails?.allowCancel) ||
      status === "submitted" ||
      status === "created" ||
      status === "backordered" ||
      ((status === "shipped" || status === "delivered") && !hasEsnToBeReturned)
    );
  })();

  const redirectToAddJobPage = () => {
    let cspAccDetails = cspDetails?.CSP?.filter((cspDetail) => cspDetail.DefaultCSP === "1")[0] || "";
    let data = {
      workTicket: {
        ...ticketDetails,
        source: source.source,
        AccountID: cspDetails?.AccountID,
        isC4SWorkTicket: true,
        appointmentLength: 0,
        startDate: moment(new Date()).add(2, "days").format("MMMM DD,YYYY"),
        id: id,
        userId,
        jobDetails: [
          {
            cspSfdcId: cspAccDetails?.CSPID || "",
            cspOwner: cspAccDetails?.CSPOwner || "",
            cspName: cspAccDetails?.CSPName || "",
            caseSfdcId: cspDetails?.CASEDetails[0]?.CaseSFDCID || "",
            caseOwner: cspDetails?.CASEDetails[0]?.CaseOwner || "",
            caseNumber: cspDetails?.CASEDetails[0]?.CaseNumber || "",
            workTickets: [
              {
                workTicket: ticketDetails.ticketId,
              },
            ],
          },
        ],
      },
      cspDetails: cspDetails,
    };
    switchTab(getOpenJobsTabIndexFromSession(), { data: data });
  };

  const showOverlay = () => {
    const overlay = document.getElementById("overlay_panel");
    if (overlay) overlay.removeAttribute("hidden");
    const firstItem = overlay?.querySelector("[role='option']");
    if (firstItem) firstItem.focus();
  };

  const handleOptionKeyDown = (e, action, actionArg) => {
    const overlay = document.getElementById("overlay_panel");
    const items = overlay ? Array.from(overlay.querySelectorAll("[role='option']")) : [];
    const idx = items.indexOf(e.currentTarget);
    if (e.key === "ArrowDown" && idx < items.length - 1) {
      items[idx + 1].focus();
    } else if (e.key === "ArrowUp" && idx > 0) {
      items[idx - 1].focus();
    } else if (e.key === "Enter") {
      handleHamburgerActions(action, actionArg);
    }
  };

  return (
    <>
      {commonModalStatus && (
        <WTCommonModal
          commonModalStatus={commonModalStatus}
          setCommonModalStatus={setCommonModalStatus}
          handleCancelShipment={handleCancelShipment}
          handleShipmentDamagedModal={handleShipmentDamagedModal}
          handleLostShipmentModal={handleLostShipmentModal}
          title={title}
          subTitle={subTitle}
          actionItem={actionItem}
          notify={notify}
          ticketDetails={ticketDetails}
          modal={modal}
        />
      )}
      {isCancelOptionModal && (
        <Modal
          role="dialog"
          ariaLabel="Cancel Ticket"
          opened={true}
          disableOutsideClick
          closeButton={
            <FlexRow justifyContent="space-between" onClick={(event) => event.preventDefault()}>
              <div css={{ paddingLeft: "0.7rem" }}>
                <Title size="medium">Cancel Ticket</Title>
              </div>
              <div style={{ marginRight: "1.3rem" }}>
                <div style={{ cursor: "pointer" }} onClick={() => setIsCancelOptionModal(false)}>
                  <Icon
                    aria-label="close"
                    alt="close-icon"
                    role="img"
                    name="close"
                    size="medium"
                    color="#000000"
                    style={{ cursor: "pointer", outline: "none" }}
                  />
                </div>
              </div>
            </FlexRow>
          }
        >
          <ModalBody css={{ padding: "16px 0 16px 16px !important" }}>
            <p style={{ fontFamily: "Verizon-NHG-eTX, Helvetica, Arial, sans-serif", fontSize: "14px" }}>
              Are you sure to cancel the workticket - {ticketDetails?.ticketId}?
            </p>
            <Spacer top="1rem" />
            <Spacer bottom="10px" />
            <FlexRow>
              <CustomSLButton aria-label="Yes" role="button" css={{ padding: "0 10px 0 10px" }} primary onClick={handleCancelWorkTicket}>
                Yes
              </CustomSLButton>
              <CustomSLButton aria-label="No" role="button" secondary onClick={() => setIsCancelOptionModal(false)}>
                No
              </CustomSLButton>
            </FlexRow>
          </ModalBody>
        </Modal>
      )}
      {isAddressUpdateModal && (
        <UpdateAddressContactModal
          isAddressUpdateModal={isAddressUpdateModal}
          setIsAddressUpdateModal={setIsAddressUpdateModal}
          // notify={notify}
          ticketDetails={ticketDetails}
        />
      )}
      {return_ReshipModalStatus && isCancelOptionModal && (
        <Modal
          role="dialog"
          ariaLabel="Return Reship Modal"
          opened={true}
          disableOutsideClick
          closeButton={
            <FlexRow justifyContent="space-between" onClick={(event) => event.preventDefault()}>
              <div css={{ paddingLeft: "0.7rem" }}>
                <Title size="medium">{title}</Title>
              </div>
              <div style={{ marginRight: "1.3rem" }}>
                <div style={{ cursor: "pointer" }} onClick={() => setIsCancelOptionModal(false)}>
                  <Icon
                    aria-label="close"
                    alt="close-icon"
                    role="img"
                    name="close"
                    size="medium"
                    color="#000000"
                    style={{ cursor: "pointer", outline: "none" }}
                  />
                </div>
              </div>
            </FlexRow>
          }
        >
          <ModalBody css={{ padding: "16px 0 16px 16px !important" }}>
            <p style={{ "font-family": "Verizon-NHG-eTX" }}>You are about to process a return and reship for this work ticket.</p>
            <p style={{ "font-family": "Verizon-NHG-eTX" }}>Are you sure you want to continue?</p>
            <Spacer top="1rem" />
            <Spacer bottom="10px" />
            <FlexRow>
              <CustomSLButton aria-label="No" role="button" secondary onClick={() => setIsCancelOptionModal(false)}>
                Cancel
              </CustomSLButton>
              <CustomSLButton aria-label="Yes" role="button" css={{ padding: "0 10px 0 10px" }} primary onClick={handleCancelWorkTicket}>
                Continue
              </CustomSLButton>
            </FlexRow>
          </ModalBody>
        </Modal>
      )}
      {splitByMaterialModal && (
        <Modal
          role="dialog"
          ariaLabel="Split by Material"
          opened={true}
          disableOutsideClick
          closeButton={
            <FlexRow justifyContent="space-between" onClick={(event) => event.preventDefault()}>
              <div css={{ fontFamily: "Verizon-NHG-eDS, Helvetica, Arial, sans-serif", paddingLeft: "0.7rem" }}>
                <Title size="medium">Split by Material</Title>
              </div>
              <div style={{ marginRight: "1.3rem" }}>
                <div style={{ cursor: "pointer" }} onClick={() => setSplitByMaterialModal(false)}>
                  <Icon
                    aria-label="close"
                    alt="close-icon"
                    role="img"
                    name="close"
                    size="medium"
                    color="#000000"
                    style={{ cursor: "pointer", outline: "none" }}
                  />
                </div>
              </div>
            </FlexRow>
          }
        >
          <ModalBody>
            <p style={{ fontFamily: "Verizon-NHG-eTX, Helvetica, Arial, sans-serif" }}>
              Splitting by material is against standard business practices and should only happen in rare cases with manager approval. Please only
              move forward if you gained approval from a deployment leader.
            </p>
            <Spacer top="1rem" />
            <Spacer bottom="10px" />
            <div>
              <input
                id="split-by-ack-checkbox"
                checked={splitByAckSelected}
                aria-checked={splitByAckSelected}
                type="checkbox"
                name="default"
                style={{ width: "20px", height: "20px" }}
                onChange={() => {
                  setSplitByAckSelected(!splitByAckSelected);
                }}
              />
              <label
                htmlFor="split-by-ack-checkbox"
                style={{
                  fontSize: "16px",
                  fontWeight: 700,
                  top: "-4px",
                  position: "relative",
                  display: "inline-block",
                  paddingLeft: "6px",
                  fontFamily: "Verizon-NHG-eDS, Helvetica, Arial, sans-serif",
                }}
              >
                Acknowledgement
              </label>
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: 400,
                  paddingLeft: "25px",
                  color: "black",
                  fontFamily: "Verizon-NHG-eTX, Helvetica, Arial, sans-serif",
                  marginTop: "4px",
                }}
              >
                By moving forward with splitting, you are acknowledging that this is approved by leadership.
              </div>
            </div>
          </ModalBody>
          <ModalFooter css={{ justifyContent: "end !important" }}>
            <FlexRow justifyContent="flex-end" width="100%">
              <CustomSLButton
                aria-label="Cancel"
                role="button"
                css={{ padding: "0 10px 0 10px" }}
                secondary
                onClick={() => setSplitByMaterialModal(false)}
              >
                Cancel
              </CustomSLButton>
              <CustomSLButton
                aria-label="Split By Material"
                disabled={!splitByAckSelected}
                role="button"
                primary
                onClick={() => {
                  setSplitByMaterialModal(false);
                  renderSplitByMaterial(ticketDetails);
                }}
              >
                Split By Material
              </CustomSLButton>
            </FlexRow>
          </ModalFooter>
        </Modal>
      )}
      <Loader active={isLoading} fullscreen />
      <OverlayPanel tabIndex={0} ref={moreOperations} id="overlay_panel" onShow={showOverlay} aria-modal="true">
        <div role="listbox" tabIndex={0}>
          {ticketDetails.installType === "VMI" &&
            ticketDetails?.hasEsnToBeReturned !== "true" &&
            (ticketDetails?.status?.toLowerCase() === "released" ||
              ticketDetails?.status?.toLowerCase() === "shipped" ||
              ticketDetails?.status?.toLowerCase() === "backordered" ||
              ticketDetails?.status?.toLowerCase() === "created" ||
              ticketDetails?.status?.toLowerCase() === "submitted" ||
              ticketDetails?.status?.toLowerCase() === "packaging" ||
              ticketDetails?.status?.toLowerCase() === "delivered") && (
              <Options
                style={{ cursor: "pointer", marginTop: "0.5rem" }}
                onClick={() => handleHamburgerActions("Schedule")}
                role="option"
                tabIndex="0"
                aria-label="Schedule"
                onKeyDown={(e) => handleOptionKeyDown(e, "Schedule")}
              >
                Schedule
              </Options>
            )}
          {ticketDetails?.status?.toLowerCase() === "error" && (
            <Options
              style={{ cursor: "pointer", marginTop: "0.5rem" }}
              onClick={() => handleHamburgerActions("Cancel")}
              role="option"
              tabIndex="0"
              aria-label="Cancel Ticket"
              onKeyDown={(e) => handleOptionKeyDown(e, "Cancel")}
            >
              Cancel Ticket
            </Options>
          )}
          {(ticketDetails?.status?.toLowerCase() === "released" ||
            ticketDetails?.status?.toLowerCase() === "backordered" ||
            ticketDetails?.status?.toLowerCase() === "submitted" ||
            ticketDetails?.status?.toLowerCase() === "created") &&
            ticketDetails?.allowCancel && (
              <Options
                style={{ cursor: "pointer", marginTop: "0.5rem" }}
                onClick={() => handleHamburgerActions("CancelShipment")}
                role="option"
                tabIndex="0"
                aria-label="Cancel Work Ticket"
                onKeyDown={(e) => handleOptionKeyDown(e, "CancelShipment")}
              >
                Cancel Work Ticket
              </Options>
            )}
          {(ticketDetails?.status?.toLowerCase() === "submitted" ||
            ticketDetails?.status?.toLowerCase() === "created" ||
            ticketDetails?.status?.toLowerCase() === "backordered") && (
            <Options
              style={{ cursor: "pointer", marginTop: "0.5rem" }}
              onClick={() => handleHamburgerActions("Update")}
              role="option"
              tabIndex="0"
              aria-label="Update Address/POC"
              onKeyDown={(e) => handleOptionKeyDown(e, "Update")}
            >
              Update Address/POC
            </Options>
          )}
          {ticketDetails?.status?.toLowerCase() === "backordered" && (
            <Options
              style={{ cursor: "pointer", marginTop: "0.5rem" }}
              onClick={() => handleHamburgerActions("Split")}
              role="option"
              tabIndex="0"
              aria-label="Split by Material"
              onKeyDown={(e) => handleOptionKeyDown(e, "Split")}
            >
              Split by Material
            </Options>
          )}
          {(ticketDetails?.status?.toLowerCase() === "shipped" || ticketDetails?.status?.toLowerCase() === "delivered") &&
            ticketDetails?.hasEsnToBeReturned !== "true" && (
              <Options
                style={{ cursor: "pointer", marginTop: "0.5rem" }}
                onClick={() => handleHamburgerActions("Return_Reship", ticketDetails.workTicket)}
                role="option"
                tabIndex="0"
                aria-label="Return/Reship"
                onKeyDown={(e) => handleOptionKeyDown(e, "Return_Reship", ticketDetails.workTicket)}
              >
                Return/Reship
              </Options>
            )}
          {(ticketDetails?.status?.toLowerCase() === "shipped" || ticketDetails?.status?.toLowerCase() === "delivered") &&
            ticketDetails?.hasEsnToBeReturned !== "true" && (
              <Options
                style={{ cursor: "pointer", marginTop: "0.5rem" }}
                onClick={() => handleHamburgerActions("ReturnOnly")}
                role="option"
                tabIndex="0"
                aria-label="Return Only After Cancellation"
                onKeyDown={(e) => handleOptionKeyDown(e, "ReturnOnly")}
              >
                Return Only After Cancellation
              </Options>
            )}
          {(ticketDetails?.status?.toLowerCase() === "shipped" || ticketDetails?.status?.toLowerCase() === "delivered") &&
            ticketDetails?.hasEsnToBeReturned !== "true" && (
              <Options
                style={{ cursor: "pointer", marginTop: "0.5rem" }}
                onClick={() => handleHamburgerActions("ReshipOnly", ticketDetails?.workTicket)}
                role="option"
                tabIndex="0"
                aria-label="Reship Only"
                onKeyDown={(e) => handleOptionKeyDown(e, "ReshipOnly", ticketDetails?.workTicket)}
              >
                Reship Only
              </Options>
            )}
        </div>
      </OverlayPanel>
      <img
        ref={buttonRef}
        data-testid="more-icon"
        style={{ width: "15px", cursor: hasOptions ? "pointer" : "not-allowed", opacity: hasOptions ? 1 : 0.3 }}
        alt="more-options-button"
        src={moreIcon}
        aria-label="more option"
        onClick={(e) => hasOptions && moreOperations.current.toggle(e)}
        tabIndex={hasOptions ? "0" : "-1"}
        role="button"
        aria-disabled={!hasOptions}
        aria-controls="overlay_panel"
        aria-expanded={false}
        aria-haspopup="listbox"
        onKeyDown={(e) => {
          if (hasOptions && (e.key === "Enter" || e.key === " ")) {
            moreOperations.current.toggle(e);
          }
        }}
      />
      {component}
    </>
  );
});
export default ThreeDotsTemplateWTA;
